/**
 * Purpose: Normalize business media into typed items so galleries never assume
 *          "media = image" (decision D-14). Today's source is the UploadedImage
 *          list; the future BusinessMedia list plugs into the same shape.
 * Inputs: business object.
 * Outputs: getBusinessMedia(business) → [{ kind, id, url, thumbnailUrl, title,
 *          is_featured, raw }]; unknown kinds are preserved so renderers can
 *          skip them gracefully.
 */
const KNOWN_KINDS = ['image', 'video', 'pdf', 'menu', 'certificate'];

const fromUploadedImage = (image, index) => ({
  kind: 'image',
  id: image.id ?? `img-${index}`,
  url: image.original_image || image.large_image || image.medium_image || image.thumbnail || null,
  thumbnailUrl: image.thumbnail || image.medium_image || image.original_image || null,
  title: image.caption || null,
  is_featured: !!image.is_featured,
  raw: image,
});

const fromBusinessMedia = (media, index) => ({
  kind: KNOWN_KINDS.includes(media.kind) ? media.kind : media.kind || 'image',
  id: media.id ?? `media-${index}`,
  url: media.url || media.file || media.original_image || null,
  thumbnailUrl: media.thumbnail || media.url || null,
  title: media.title || null,
  is_featured: !!media.is_featured,
  raw: media,
});

export const getBusinessMedia = (business) => {
  // Future BusinessMedia list takes precedence when the backend ships it (D-14).
  if (Array.isArray(business?.media) && business.media.length > 0) {
    return business.media.map(fromBusinessMedia);
  }
  return (business?.images || []).map(fromUploadedImage);
};

export const imageMediaOnly = (mediaItems) => mediaItems.filter((m) => m.kind === 'image');
